import { render, staticRenderFns } from "./FaceAuatarList.vue?vue&type=template&id=64b19e72&scoped=true&"
import script from "./FaceAuatarList.vue?vue&type=script&lang=js&"
export * from "./FaceAuatarList.vue?vue&type=script&lang=js&"
import style0 from "./FaceAuatarList.vue?vue&type=style&index=0&id=64b19e72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b19e72",
  null
  
)

export default component.exports